export const SIMPLE = "simple";
export const ADVANCED = "advanced";
